module.exports = __webpack_public_path__ + "img/badge_color_adv-supports.1d91437d.svg";